import React from 'react';
import MainInfoTracLayout from '../../../../components/Layout/Main';
import Content from '../../../../components/Pages/InsertManagement/Edit/Step5';

function InsertManagementEditStep5() {
  return (
    <MainInfoTracLayout className="min-h-[100vh] bg-white" isOldPage>
      <Content />
    </MainInfoTracLayout>
  );
}

export default InsertManagementEditStep5;
